/**
 * Honeybadger reporting-environment rules.
 *
 * Maps the current hostname to the environment name used by Honeybadger
 * deploy tracking and source map uploads (dev, stg, prod), and decides
 * whether the current host is allowed to report at all.
 *
 * @memberof @albert-io/notifier
 */

const ENVIRONMENT_RULES = [
  {domain: 'albert-dev.net', env: 'dev'},
  {domain: 'albert-stg.net', env: 'stg'},
  {domain: 'albert.io', env: 'prod'}
];

export const getHoneybadgerEnvironment = (hostname = global.window?.location?.hostname || '') => {
  const match = ENVIRONMENT_RULES.find(
    (rule) => hostname === rule.domain || hostname.endsWith(`.${rule.domain}`)
  );
  // should never report to Honeybadger with an environment of 'localhost', since we don't send honeybadger reports from localhost, but this is a fallback just in case
  return match ? match.env : 'localhost';
};

/**
 * Only hosts mapping to a known environment may report — everything else is
 * local dev or a rehosted copy (translation proxies, mirrors) whose errors we
 * cannot act on (#18857).
 */
export const isKnownReportingHost = (hostname) =>
  getHoneybadgerEnvironment(hostname) !== 'localhost';
